export const createUser = /* GraphQL */ `
  mutation CreateUserCustom($input: CreateUserInput!, $condition: ModelUserConditionInput) {
    createUser(input: $input, condition: $condition) {
      id
      email
      firstName
      lastName
      phone
      address {
        houseNumber
        street
        streetType
        address1
        address2
        address3
        city
        state
        postalCode
        county
        country
        latLng {
          lat
          lon
        }
      }
      avatar
      userBio
      age
      dateOfBirth
      genderId
      createdAt
      status
      referralSource
      roles
      metadata {
        lastLogin
        trialStartDate
        trialEndDate
        subscriptionStatus
        deviceId
        deviceOS
        deviceOSVersion
        allowAccountNotifications
        allowMarketingNotifications
        allowCoachingNotifications
        initialAssessmentCompletedDate
        lastWeeklyCheckinDate
        lastGrowthStageAssessmentDate
        primaryFocusCategoryId
        primaryFocusGoalId
        secondaryFocusCategoryId
        secondaryFocusGoalId
        tertiaryFocusCategoryId
        tertiaryFocusGoalId
        preferredCoachingTimeOfDay
        preferredCoachingDaysOfWeek
        primaryCoachId
        userIPAddress
        intakeCompleted
        onboardingCompleted
        issCompleted
        stipeCustomerId
        lastActive
      }
      updatedAt
    }
  }
`;
